import React, { Component } from "react";
import NavBar from "../Componentes/NavBar";
import Tabs from "../Componentes/Tabs";
import AgregaEventos from "../Componentes/AgregaEventos";
import Grid from "@material-ui/core/Grid";
import CartaEventos from "../Componentes/CartaEventos";
import "./Eventos.css";
import FadeIn from "react-fade-in";
import fire from "../config/Fire";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      pictures: [],
      picturesa: []
    };
  }
  //realiza la consulta de los eventos
  componentDidMount() {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ picturesa: [] });

        fire
          .database()
          .ref()
          .child("Eventos")
          .on("value", snapshot => {
            this.setState({ pictures: [] });
            Object.entries(snapshot.val()).map(ids => {
              return this.setState({
                pictures: this.state.pictures.concat(ids[1])
              });
            });
            //this.setState({ pictures: this.state.picturesa.reverse() });
          });
      }
    });
  }
  //realiza el render de los componentes
  render() {
    return (
      <div>
        <NavBar />
        <Tabs />
        <FadeIn>
          <div className="content">
            <Grid container spacing={40} alignItems="center">
              <Grid item xs={12}>
                <AgregaEventos />
              </Grid>
            </Grid>
            <Grid container spacing={24} alignItems="center">
              {this.state.pictures.map(card => {
                return (
                  <Grid item sm={6} md={4} lg={3}>
                    <CartaEventos
                      titulo={card.titulo}
                      direccion={card.direccion}
                      detalle={card.detalle}
                      fecha={card.fecha}
                      hashtag={card.hashtag}
                      link={card.link}
                      nombreimg={card.nombreimg}
                      precio={card.precio}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </FadeIn>
      </div>
    );
  }
}

export default Home;
